import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, MessageCircle, Mail, Calendar } from "lucide-react";
import api from "../lib/api";
import Avatar from "../components/Avatar";
import { formatDate } from "../lib/format";

export default function MemberDetail() {
  const { id } = useParams();
  const [m, setM] = useState(null);

  useEffect(() => {
    api.get(`/members/${id}`).then((r) => setM(r.data));
  }, [id]);

  if (!m) return <div className="text-[#9A9590]">Loading…</div>;

  return (
    <div className="space-y-10" data-testid="member-detail-page">
      <Link to="/members" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#9A9590] hover:text-[#C9A84C] transition">
        <ArrowLeft size={14} /> Back to directory
      </Link>

      <div className="ts-card p-8 sm:p-12 flex flex-col sm:flex-row gap-8">
        <Avatar name={m.name} photoUrl={m.photo_url} color={m.avatar_color} size={120} />
        <div className="flex-1 min-w-0">
          <div className="overline">{m.group_role}</div>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#F0EDE8] mt-2">{m.name}</h1>
          <div className="text-[#C9A84C] text-sm uppercase tracking-[0.3em] mt-3">{m.sector}</div>

          <div className="flex flex-wrap gap-2 mt-5">
            {(m.sub_specialties || []).map((s) => (
              <span key={s} className="text-[10px] uppercase tracking-widest text-[#9A9590] border border-[#C9A84C]/20 rounded-full px-3 py-1">
                {s}
              </span>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-[#9A9590]">
            {m.email && (
              <a href={`mailto:${m.email}`} className="inline-flex items-center gap-2 hover:text-[#C9A84C] transition" data-testid="member-email">
                <Mail size={14} /> {m.email}
              </a>
            )}
            {m.whatsapp && (
              <a
                href={`https://wa.me/${m.whatsapp.replace(/\D/g, "")}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 hover:text-[#C9A84C] transition"
                data-testid="member-whatsapp"
              >
                <MessageCircle size={14} /> {m.whatsapp}
              </a>
            )}
            <span className="inline-flex items-center gap-2">
              <Calendar size={14} /> Member since {formatDate(m.member_since)}
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="ts-card p-7">
          <div className="overline">Typical client</div>
          <p className="mt-3 text-[#F0EDE8] leading-relaxed">{m.typical_client || "—"}</p>
        </div>
        <div className="ts-card p-7">
          <div className="overline">Status</div>
          <p className="mt-3 text-[#F0EDE8]">{m.status === "on_leave" ? "On Leave" : "Active"}</p>
          <div className="mt-2 text-sm text-[#9A9590]">{m.active_deals_count} active deals on the table.</div>
        </div>
        <div className="ts-card p-7 md:col-span-2">
          <div className="overline">What they bring</div>
          <p className="mt-3 text-[#F0EDE8] leading-relaxed">{m.what_they_bring || "—"}</p>
        </div>
        <div className="ts-card p-7 md:col-span-2">
          <div className="overline">What they are looking for</div>
          <p className="mt-3 text-[#F0EDE8] leading-relaxed">{m.what_they_seek || "—"}</p>
        </div>
      </div>
    </div>
  );
}
